import { Col, Input } from 'antd';
import { WrapperPopover } from './WrapperFactsPanelItem';
import { WrapperSelect } from 'common/components';

export const WrapperIngredient = (props) => {
  const { value, originValue, type, children } = props;

  const overlayValue =
    JSON.stringify(value) !== JSON.stringify(originValue) ? originValue : null;

  if (!overlayValue) return <>{children}</>;

  return (
    <WrapperPopover
      content={<RenderIngredients value={overlayValue} type={type} />}
      title='Origin value'
      trigger='hover'
      placement='left'
    >
      <div
        style={{ outline: 'solid 3px rgba(0, 112, 204, 0.4)', borderRadius: 4 }}
      >
        {children}
      </div>
    </WrapperPopover>
  );
};

const RenderIngredients = ({ value, type = 'statement' }) => {
  return (
    <Col span={24}>
      {type === 'statement' && (
        <>
          <p className='title-section'>Ingredients Statement</p>
          <Input.TextArea
            rows={3}
            maxLength={3000}
            value={value}
            readOnly
            style={{ cursor: 'default' }}
          />
        </>
      )}
      {type === 'breakout' && (
        <>
          <p className='title-section'>Ingredients Breakout</p>
          <WrapperSelect
            mode='tags'
            style={{ width: '100%', pointerEvents: 'none' }}
            placeholder='INGREDIENTS'
            name='ingredients'
            listItemHeight={10}
            listHeight={250}
            value={value}
          />
        </>
      )}
    </Col>
  );
};
